module.exports = __webpack_public_path__ + "static/media/claim_it.d691a90b.webp";